// @flow
import PageNode from 'components/page/PageNode';
import { connect } from 'react-redux';
import { fetchAlbums } from 'actions/albumActions';
import { fetchPageNode, resetPageNode } from 'actions/pageActions';
import { fetchPartenaire } from 'actions/partenaireActions';

import type { DispatchProps, StateProps } from 'components/page/PageNode';
import type { DispatchType, StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      albums: state.albumState.albums,
      albums_filtres: state.pageListState.albums_filtres,
      albums_saisons: state.pageListState.albums_saisons,
      albumsStatus: state.albumState.albumsStatus,
      contentNode: state.pageNodeState.pageNode.content,
      featured_media: state.pageNodeState.pageNode.featured_media,
      liste_enfants: state.pageNodeState.pageNode.liste_enfants,
      pageDetailSidebar: state.pageDetailState.sidebar_content,
      pageDetailTemplate: state.pageDetailState.template,
      partenaire: state.partenaireState.partenaire,
      title: state.pageNodeState.pageNode.title,
      sidebar: state.pageNodeState.pageNode.sidebar_content,
      slug_parent: state.pageNodeState.pageNode.slug_parent,
      status: state.pageNodeState.status,
      statusPartner: state.partenaireState.partenaireStatus,
      template: state.pageNodeState.pageNode.template,
      titleParent: state.pageNodeState.pageNode.titleParent
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchAlbums: () => dispatch(fetchAlbums()),
      fetchPageNode: (slug: string) => dispatch(fetchPageNode(slug)),
      fetchPartenaire: (slug: string) => dispatch(fetchPartenaire(slug)),
      resetPageNode: () => dispatch(resetPageNode())
    })
  )(PageNode)
);
